import { mobileButtonCSS } from '@src/components/Mobile/styles';
import { Box, Flex, IconButton, Stack } from '@talos/kyoko';
import styled from 'styled-components';

export const MOBILE_HEADER_HEIGHT = 54;
export const MOBILE_TOOLBAR_HEIGHT = 44;

export const MobileHeaderWrapper = styled(Stack)`
  height: ${MOBILE_HEADER_HEIGHT}px;
  gap: ${({ theme }) => theme.spacing10}px;
  transition: transform 300ms linear;
  padding: 0 16px;
  padding-top: calc(env(safe-area-inset-top) + 12px);
  z-index: 1001;
`;

export const MOBILE_HEADER_TITLE_FONT_SIZE = 2.125;
export const MOBILE_HEADER_TITLE_LINE_HEIGHT = 2.5625;
export const MobileHeaderTitle = styled(Box)<{ hide?: boolean }>`
  z-index: 1000;
  color: ${({ theme }) => theme.colorTextImportant};
  font-weight: ${({ theme }) => theme.fontWeightBold};
  white-space: nowrap;
  transition:
    opacity 300ms linear,
    filter 300ms linear,
    transform 300ms linear,
    width 300ms linear;
  filter: ${({ opacity }) =>
    opacity != null && typeof opacity === 'number' && opacity < 1 ? `blur(${10 * (1 - opacity)}px)` : 'none'};
`;
MobileHeaderTitle.defaultProps = {
  fontSize: MOBILE_HEADER_TITLE_FONT_SIZE,
  lineHeight: `${MOBILE_HEADER_TITLE_LINE_HEIGHT}rem`,
  w: 0,
};

export const MOBILE_HEADER_DESCRIPTION_FONT_SIZE = 0.9375;
export const MOBILE_HEADER_DESCRIPTION_LINE_HEIGHT = 1.25;
export const MobileHeaderDescription = styled(Box)`
  color: ${({ theme }) => theme.colorTextDefault};
  white-space: nowrap;
  transition:
    opacity 300ms linear,
    filter 300ms linear,
    transform 300ms linear;
  font-weight: 500;
`;
MobileHeaderDescription.defaultProps = {
  fontSize: MOBILE_HEADER_DESCRIPTION_FONT_SIZE,
  lineHeight: `${MOBILE_HEADER_DESCRIPTION_LINE_HEIGHT}rem`,
};

export const ToolbarWrapper = styled(Flex)`
  height: ${MOBILE_HEADER_HEIGHT}px;
  padding: 0 ${({ theme }) => theme.spacing16}px;
  align-items: center;
  position: fixed;
  top: max(env(safe-area-inset-top), 8px);
  right: 0;
  left: 0;
  z-index: 1000;
`;

export const ToolbarButtonWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  border-radius: ${MOBILE_TOOLBAR_HEIGHT / 2}px;
  transition:
    opacity 300ms linear,
    filter 300ms linear,
    width 300ms linear;
  ${mobileButtonCSS};

  & > ${IconButton} {
    background: transparent;
    color: ${({ theme }) => theme.colorTextDefault};

    &:active {
      color: ${({ theme }) => theme.colorTextImportant};
    }
  }

  &:is(:empty) {
    display: none;
  }
`;
ToolbarButtonWrapper.defaultProps = {
  h: MOBILE_TOOLBAR_HEIGHT,
  p: 'spacing6',
  gap: 'spacing4',
};

export const MobileHeaderSpacer = styled(Box)`
  margin-top: max(env(safe-area-inset-top), 8px);
  height: ${MOBILE_HEADER_HEIGHT}px;
  flex-shrink: 0;
`;
